import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import moment from "moment"
import { Button, Col, Table } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import Gallery from "react-grid-gallery"
import { connect } from "react-redux"
import { blockingFetchService } from "../../../lib/blockingFetch"
import * as ItemTypes from "../../../redux/items/types"
import processTypes from "../../../redux/processes/types"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import DeleteHistoricalConfirmModal from "./DeleteHistoricalConfirmModal"
import './styles.css'

class QRCodeScreenComponent extends React.Component {

  updateID = null
  checkingInterval = 60 * 2 * 1000

  state = {
    running: false,
    success: false,
    error: null,
    images: [],
    selectedSessionId: null,
    showConfirmDeletion: false,
  }

  componentDidMount() {
    this.props.loadQRCodes()
    this.props.updateQRCodes()
    this.launchUpdateQR()
  }

  launchUpdateQR = () => {
    this.updateID = setInterval(() => {
      if(this.props.qrcodes && this.props.qrcodes.length) {
        this.props.updateQRCodes()
      }
    }, this.checkingInterval)
  }

  componentWillUnmount() {
    clearInterval(this.updateID)
  }

  retrieveQRcode(currentSessionId, reloadHistorical) {

    this.setState({
      running: true,
      success: false,
      error: null,
      selectedSessionId: currentSessionId,
    })

    blockingFetchService(
      accessToken => apiServerApi.getOfflineQRCode(accessToken, currentSessionId), 
      response => {

        const { sessionId, qrcode, sideloadingqr, provisioningqr } = response,

          thumbnailWidth = 220,
          thumbnailHeight = 220,
          images = []

        images.push({
          src: qrcode,
          thumbnail: qrcode,
          caption: "Full QR code",
          thumbnailCaption: "Full QR code",
          thumbnailWidth,
          thumbnailHeight,
        })

        images.push({
          src: sideloadingqr,
          thumbnail: sideloadingqr,
          caption: "Sideloading QR code",
          thumbnailCaption: "Sideloading QR code",
          thumbnailWidth,
          thumbnailHeight,
        })

        images.push({
          src: provisioningqr,
          thumbnail: provisioningqr,
          caption: "Provisioning QR code",
          thumbnailCaption: "Provisioning QR code",
          thumbnailWidth,
          thumbnailHeight,
        })

        this.setState({
          images,
          selectedSessionId: sessionId,
          success: true,
        })

        if(reloadHistorical) {
          this.props.loadQRCodes()
        }
      },
      error => this.setState({ error: error.text }),
      () => this.setState({ running: false })
    )
  }

  confirmDeletion = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
      showConfirmDeletion: false,
    })

    blockingFetchService(
      accessToken => apiServerApi.deleteQRHistorical(accessToken), 
      _ => {
        this.setState({ success: true, images: [] })
        this.props.loadQRCodes()
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  showDeletionModal = () => this.setState({ showConfirmDeletion: true })

  closeConfirmDeletion = () => this.setState({ showConfirmDeletion: false })

  renderQRcodeTr = (item, index) => {

    const seleted = this.state.selectedSessionId === item.sessionId ? 'qr-seleted-tr' : '',
      qrcodeColor = item.imei ? 'green' : 'gray',
      idColor = item.imei ? 'green' : 'dark-gray',
      title = 'Click to load - '
        + (item.imei ? 'An IMEI is associated with this QR code' : 'No IMEI associated with this QR code')

    return <tr key={ index } className={ `cursor-pointer ${ seleted }` } title={ title }
      onClick={_ => this.retrieveQRcode(item.sessionId, false)}>
      <td className="v-center">
        <FontAwesome name='qrcode' size="lg" className={ qrcodeColor }/>
        { item.imei ? <small className="light-green"> <FontAwesome name='check-circle' size="lg"/></small> : null }
      </td>

      <td className="v-center">
        <span className={ idColor }>{ item.id }</span><br/>
        <small className="gray">
          <FontAwesome name='calendar'/> { moment(item.createdOn).format('lll') }
        </small>
      </td>
    </tr>
  }

  renderHistorical = qrcodes =>  
    <div className="historical-table">
    { qrcodes && qrcodes.length 
    ? <Table striped condensed hover responsive>
        <tbody>{ qrcodes.map((item, index) => this.renderQRcodeTr(item, index)) }</tbody>
      </Table>
    : <p className="align-center"><small>-- No data --</small></p>
    }
    </div>

  renderNoActivity = (running, error,) =>
    <div className="qrzone-noactivity">
    { running
      ? <span>Running...</span>
      : error
        ? <p className="error-color">{ error }</p>
        : <FontAwesome name='qrcode' size="5x" className="gray"/>
    }
    </div>

  render() {

    const { qrcodes, failed, result } = this.props,
      { running, error, images, showConfirmDeletion } = this.state,
      noActivity = running || error || !images.length

    return (
      <div>
        <CustomBreadCrumb activeText='QR codes' data={ [{ url: '/settings', title: 'Settings' }] } />

        <Col md={8} className="qrzone">

          { noActivity
            ? this.renderNoActivity(running, error)
            : <div>
              <Gallery rowHeight={220} images={ images }
                enableImageSelection={false} showLightboxThumbnails={true} />
              <small className="click-to-expand hot-color">
                <FontAwesome name='expand'/> Click on images to expand
              </small>
            </div>
          }

          <p className="newqrcode">
            <Button bsStyle="info" onClick={_ => this.retrieveQRcode(null, true)}
              disabled={ running }
              title="Request a new QR code">
              <FontAwesome name='plus'/> New QR code
            </Button>
          </p>
        </Col>

        <Col md={4} className="custom-scrollbars">
          <strong className="historical-title align-center blue">Requests History
            { qrcodes && qrcodes.length
            ? <small className="hot-color cursor-pointer" title='Delete all'
                onClick={ this.showDeletionModal }>
                &nbsp; &nbsp; &nbsp; <FontAwesome name="trash-o" /> Delete all
              </small>
            : null
            }
          </strong>

          { (failed && result && result.result) 
            ? <p className="error-color"><small>{ result.result.text }</small></p>
            : null
          }

          { this.renderHistorical(qrcodes) }
        </Col>

        <DeleteHistoricalConfirmModal
          show={ showConfirmDeletion }
          close={ this.closeConfirmDeletion }
          confirm={ this.confirmDeletion }
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const mapping = {
    qrcodes: DckSelectors.selectAllItems(state, ItemTypes.QRCode),

    failed: DckSelectors.selectProcessFailed(
      state,
      processTypes.LOAD_QRCODE_PROCESS
    ),

    running: DckSelectors.selectProcessRunning(
      state,
      processTypes.LOAD_QRCODE_PROCESS
    ),

    result: DckSelectors.selectProcess(state, processTypes.LOAD_QRCODE_PROCESS),
  }

  return mapping
}

const mapDispatchToProps = dispatch => ({
  loadQRCodes: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.QRCode)),
  updateQRCodes: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.UpdateQRCode))
})

export default connect(mapStateToProps, mapDispatchToProps)(QRCodeScreenComponent)


// WEBPACK FOOTER //
// ./src/components/Settings/QRcodes/index.js